import React from "react";
import BlogCard from "../component/BlogCard";
import BreadCumb from "../component/BreadCumb";
import {Helmet} from "react-helmet-async";

const Blog = () => {
    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | News & Blogs</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href="https://tarifoverseasltd.com/blogs"/>
            </Helmet>
            <main className="main">
                <BreadCumb image="blogs.webp" />
                <BlogCard />

            </main>
        </>
    );
}

export default Blog;